<div class="thermometer-widget-placeholder">
  <ng-container *ngIf="!hasImage; else customImage">
    <svg
      class="thermometer-svg"
      [attr.id]="'thermometer-' + (thermometerWidget?.uuid || '')"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 141 438.1"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        class="thermometer-bg"
        d="M136.5,367.6c0,36.44-29.54,66-66,66S4.5,404.04,4.5,367.6c0-19.47,8.42-36.96,21.82-49.04,2.07-1.87,3.2-4.56,3.2-7.35V45.48c0-1.1.04-2.19.13-3.27,1.67-21.11,19.31-37.71,40.84-37.71s39.17,16.61,40.84,37.71c.09,1.08.13,2.17.13,3.27v265.72c0,2.79,1.13,5.48,3.2,7.35,13.4,12.08,21.82,29.57,21.82,49.04Z"
        [attr.fill]="thermometerBackgroundColor"
      />

      <g class="thermometer-fill" [style.clip-path]="clipInset" [style.-webkit-clip-path]="clipInset">
        <path
          class="thermometer-fill-path"
          d="M136.5,367.6c0,36.44-29.54,66-66,66S4.5,404.04,4.5,367.6c0-19.47,8.42-36.96,21.82-49.04,2.07-1.87,3.2-4.56,3.2-7.35V45.48c0-1.1.04-2.19.13-3.27,1.67-21.11,19.31-37.71,40.84-37.71s39.17,16.61,40.84,37.71c.09,1.08.13,2.17.13,3.27v265.72c0,2.79,1.13,5.48,3.2,7.35,13.4,12.08,21.82,29.57,21.82,49.04Z"
          [attr.fill]="thermometerColor"
        />
      </g>

      <path
        class="thermometer-outline"
        d="M136.5,367.6c0,36.44-29.54,66-66,66S4.5,404.04,4.5,367.6c0-19.47,8.42-36.96,21.82-49.04,2.07-1.87,3.2-4.56,3.2-7.35V45.48c0-1.1.04-2.19.13-3.27,1.67-21.11,19.31-37.71,40.84-37.71s39.17,16.61,40.84,37.71c.09,1.08.13,2.17.13,3.27v265.72c0,2.79,1.13,5.48,3.2,7.35,13.4,12.08,21.82,29.57,21.82,49.04Z"
        fill="none"
        [attr.stroke]="thermometerBorderColor"
      />
    </svg>
  </ng-container>
  <ng-template #customImage>
    <div class="thermometer-image-wrapper" *ngIf="imageUrl">
      <img class="image-mask" [src]="imageUrl" />
      <img class="main-image" [src]="imageUrl" [style.clip-path]="clipInset" [style.-webkit-clip-path]="clipInset" />
    </div>
  </ng-template>
</div>
